import {Fragment, PureComponent} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import Loader from '../../../../shared/components/Loader/Loader.jsx'

import {setMeetingScheduled} from '../../../components/CurrentUserLoader/actions.js'
import ManagersPresentation from "../../../../shared/components/ManagersPresentation/ManagersPresentation.jsx"

const calendlyJS = 'calendly-js'
const calendlyCSS = 'calendly-css'

class MeetingStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    this.setupCalendly()
  }

  componentWillUnmount() {
    this.removeCalendlyListener()
  }

  setupCalendly = () => {
    this.setState({loading: true})

    const head = document.getElementsByTagName('head')[0]

    const script = document.createElement("script")
    script.src = 'https://assets.calendly.com/assets/external/widget.js'
    script.id = calendlyJS
    script.async = true
    script.onload = () => this.setState({loading: false})

    const link = document.createElement('link')
    link.href = 'https://assets.calendly.com/assets/external/widget.css'
    link.id = calendlyCSS
    link.rel = 'stylesheet'

    head.appendChild(script)
    head.appendChild(link)

    window.addEventListener('message', this.handleMessage)
  }

  removeCalendlyListener = () => {
    const head = document.getElementsByTagName('head')[0]

    head.removeChild(document.getElementById(calendlyJS))
    head.removeChild(document.getElementById(calendlyCSS))

    window.removeEventListener('message', this.handleMessage)
  }

  sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  handleMessage = (event) => {
    if (this.isCalendlyEvent(event) && event.data.event === 'calendly.event_scheduled') {
      window.Calendly.closePopupWidget()
      this.props.setMeetingScheduled(true)
    }
  }

  isCalendlyEvent = (e) => {
    return e.data.event &&
      e.data.event.indexOf('calendly') === 0
  }

  openCalendlyWidget = (e) => {
    const calendlyUrl = this.props.currentUniverse?.calendly_url ?? null
    e.preventDefault()
    if (
      !this.props.currentUser?.meeting?.start_time &&
      !this.props.currentUser?.hasMeetingScheduled &&
      null !== calendlyUrl
    ) {
      window.Calendly.initPopupWidget({
        url: calendlyUrl,
        prefill: {
          firstName: this.props.currentUser?.firstname ?? null,
          lastName: this.props.currentUser?.lastname ?? null,
          email: this.props.currentUser?.email ?? null,
          customAnswers: {
            a1: this.props.currentUser?.tel ?? null
          }
        }
      })
    }
  }

  render() {
    if (this.state.loading) {
      return <Loader visible={this.state.loading}>Chargement en cours...</Loader>
    }

    return <Fragment>
      <h2 className="text-center">Planifier une rencontre en visio</h2>
      <p>
        <strong>Quelle que soit votre situation actuelle : </strong>
        en CDI, en recherche ou consultant indépendant, rencontrez l'un
        de nos managers afin de discuter de votre situation !
      </p>
      <p className="text-center">
        <button className="btn btn-primary" onClick={this.openCalendlyWidget}>Prendre rendez-vous</button>
      </p>
      <p>
        <strong>Cet échange n'est pas un entretien d'embauche et ne vous engage absolument en rien ! </strong>
        Il a simplement pour objectif de :
      </p>
      <ul>
        <li>Evoquer vos envies et contraintes</li>
        <li>Comprendre votre profil et vos expériences</li>
        <li>Déterminer les opportunités que l'on peut vous apporter</li>
      </ul>
      <p>
        Nos managers rencontrent toutes les personnes inscrites sur la plateforme afin de
        <strong> garantir la qualification des profils à nos clients.</strong>
      </p>
      <ManagersPresentation/>
      <p className="text-center" style={{marginTop: -55}}>
        <button className="btn btn-primary" onClick={this.openCalendlyWidget}>Prendre rendez-vous</button>
      </p>
    </Fragment>
  }
}

export default connect(
  (state) => ({
    currentUniverse: state.universe?.currentUniverse ?? null,
  }),
  (dispatch) => ({
    setMeetingScheduled: (hasMeetingScheduled) => dispatch(setMeetingScheduled(hasMeetingScheduled)),
  })
)(MeetingStep)